import { Box, Typography, SxProps } from '@mui/material';
import truncate from 'lodash/truncate';

import { FC } from 'react';

export interface TooltipContentProps {
    title: string;
    snippet?: string;
    subtitles?: string[];
}

const tooltipSx: SxProps = {
    '& *': {
        fontSize: 'caption.fontSize',
    },
    padding: 1,
};

const TooltipContent: FC<TooltipContentProps> = ({ title, snippet, subtitles }) => {
    const filteredSubtitles = subtitles?.filter(Boolean);

    return (
        <Box sx={tooltipSx}>
            <Typography sx={{ fontWeight: 'medium' }}>{title}</Typography>
            {filteredSubtitles?.length && filteredSubtitles.length > 0 ? (
                <Typography variant="caption" gutterBottom>
                    {filteredSubtitles.join(' — ')}
                </Typography>
            ) : null}
            {snippet && (
                <Typography>
                    {truncate(snippet, { length: 250, omission: ' …', separator: ' ' })}
                </Typography>
            )}
        </Box>
    );
};

export default TooltipContent;
